module.exports = function getResource(label) {
    let resources = { qty: 'Quantity' };
    return resources[label];
};
